import React, { useEffect, useRef } from "react";
import { v4 as uuidv4 } from "uuid";
import { Carousel } from "antd";
import Img1 from "../../src/assetes/img1.jpeg";
import Img2 from "../../src/assetes/img2.jpeg";
import Img3 from "../../src/assetes/img3.jpeg";
import Img4 from "../../src/assetes/img4.jpeg";
import Img5 from "../../src/assetes/img5.jpeg";
import Img6 from "../../src/assetes/img6.jpeg";
import Img7 from "../../src/assetes/img7.jpeg";
import Img8 from "../../src/assetes/img8.jpeg";
import Img9 from "../../src/assetes/img9.jpeg";
import Img10 from "../../src/assetes/img10.jpeg";
import Img11 from "../../src/assetes/img11.jpeg";
import Img12 from "../../src/assetes/img12.jpeg";
import Img13 from "../../src/assetes/img13.jpeg";

import { register } from "swiper/element/bundle";

const ImageCarousel = () => {
  const swiperRef = useRef(null);

  useEffect(() => {
    register();

    const params = {
      slidesPerView: 4,
      navigation: true,
      virtual: {
        enabled: true,
      },
      effect: "coverflow",
      breakpoints: {
        768: {
          slidesPerView: 4,
        },
        320: {
          slidesPerView: 1,
        },
        420: {
          slidesPerView: 1,
        },
      },
    };

    Object.assign(swiperRef.current, params);

    swiperRef.current.initialize();
  }, []);
  const slides = [
    {
      key: uuidv4(),
      content: Img1,
    },
    {
      key: uuidv4(),
      content: Img2,
    },
    {
      key: uuidv4(),
      content: Img3,
    },
    {
      key: uuidv4(),
      content: Img4,
    },
    {
      key: uuidv4(),
      content: Img5,
    },
    {
      key: uuidv4(),
      content: Img6,
    },
    {
      key: uuidv4(),
      content: Img7,
    },
    {
      key: uuidv4(),
      content: Img8,
    },
    {
      key: uuidv4(),
      content: Img9,
    },
    {
      key: uuidv4(),
      content: Img10,
    },
    {
      key: uuidv4(),
      content: Img11,
    },
    {
      key: uuidv4(),
      content: Img12,
    },
    {
      key: uuidv4(),
      content: Img13,
    },
  ];

  return (
    <div className="w-full h-auto flex">
      <div className="w-full mt-5">
        {/* <Carousel arrows infinite>
          {slides.map((item) => {
            return (
              <div className="w-full h-60 bg-slate-500">
                <img
                  src={item.content}
                  className="w-full h-full object-contain"
                />
              </div>
            );
          })}
        </Carousel> */}

        

        <swiper-container init="false" ref={swiperRef}>
          {slides.map((item) => {
            return (
              <swiper-slide key={item.key}>
                <div className="w-full h-60 bg-white shadow-md rounded-md flex justify-center">
                  <img
                    src={item.content}
                    className="w-full h-full object-contain"
                  />
                </div>
              </swiper-slide>
            );
          })}
        </swiper-container>

        {/* <div class="custom-shape-divider-bottom-1718734852">
          <svg
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
          >
            <path
              d="M1200,0H0V120H281.94C572.9,116.24,602.45,3.86,602.45,3.86h0S632,116.24,923,120h277Z"
              class="shape-fill"
            ></path>
          </svg>
        </div> */}
      </div>

      <div></div>
    </div>
  );
};

export default ImageCarousel;
